import { Injectable } from "@angular/core";
import { ArticleType, CareAccessoryOrderItem} from "src/app/model/order/order";

@Injectable()
export class CareAndAccessoriesService {
    convertCareAccessoriesToOrderItem(item: any, type: ArticleType, quantity: number): CareAccessoryOrderItem {
        let newItem: CareAccessoryOrderItem = {
            article: {
              id: item.id,
              type: type,
              name: item.name,
              imageUrl: item.imageUrl,
              electronicOrdering: item.electronicOrdering? item.electronicOrdering: true,
            },
            count: quantity,
        };
        return newItem;
    }
}
